<template functional>
  <div class="icon" :class="[`icon-${props.name}`, `${props.size}-size`, `${props.fill}-fill`]" />
</template>

<script>
export default {
  name: "Icon",
  props: {
    name: {
      type: String,
      default: ""
    },
    size: {
      type: String,
      default: "big"
    },
    fill: {
      type: String,
      default: "white"
    }
  }
};
</script>
